import { useQuery } from '@apollo/client'
import { GET_MY_PERMISSIONS } from '../Graphql/Queries'
import { setPermissions } from '../Store/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux'
/**
 * This hook is the single point of truth for permissions a user has.
 * Various pages and UI components use this to show/hide components
 * throughout the application
 */
const useUserPermissions = () => {
  const dispatch = useDispatch()
  const { loading, error, client } = useQuery(GET_MY_PERMISSIONS, {
    onCompleted: (data) => {
      dispatch(setPermissions(data.userPermissions))
    },
    fetchPolicy: 'network-only',
  })

  const permissions = useSelector((state: any) => state.auth.permissions)

  return { permissions, loading, error, client }
}

export default useUserPermissions
